import { render, staticRenderFns } from "./SupportChatTimeline.vue?vue&type=template&id=f2141dae&scoped=true"
import script from "./SupportChatTimeline.vue?vue&type=script&lang=js"
export * from "./SupportChatTimeline.vue?vue&type=script&lang=js"
import style0 from "./SupportChatTimeline.vue?vue&type=style&index=0&id=f2141dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2141dae",
  null
  
)

export default component.exports